import {LTServices} from "../../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import VectorSource from "ol/source/Vector";
import {Feature} from "ol";
import {Geometry} from "ol/geom";

export abstract class FeatureMarkupService {
    abstract getSources() : ng.IPromise<VectorSource<Geometry>[]>;
    abstract filterFeature(feature: Feature<Geometry>, source: VectorSource<Geometry>) : boolean;
    protected init() {
    }
}

export class ContextFeatureMarkupService extends FeatureMarkupService {
    protected sources: ng.IPromise<VectorSource<Geometry>[]> = this.$q.resolve([this.mapService.featuresLayer.getSource()]);

    filterFeature(feature: Feature<Geometry>, source: VectorSource<Geometry>): boolean {
        return true;
    }

    getSources(): ng.IPromise<VectorSource<Geometry>[]> {
        return this.sources;
    }

    lazyProperty<T>(feature: Feature<Geometry>, key: string, propertyLoader: () => ng.IPromise<T>, loadingVal: T|string = 'loading') {
        let currentVal = feature.get(key);
        if (currentVal !== undefined || currentVal == 'loading') return;
        feature.set(key, loadingVal);
        propertyLoader().then((val: T) => {
            feature.set(key, val);
        });
    }
    public static $inject = [ '$http', '$q', 'landcareMapService' ];

    constructor(protected $http: ng.IHttpService, protected $q: ng.IQService, protected mapService: IMapService) {
        super();
        this.init();
    }
}